import { useQuery } from '@apollo/client';

import { useAccountCompanyId } from 'application/hooks';

import { useCompanyCreateAmoTaskToBill } from '@entities/billing';
import { AuthCurrentUserQuery, AuthCurrentUserDocument } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import { UseInvoiceRequestViewModel } from './types';

const useInvoiceRequestPresenter = (): UseInvoiceRequestViewModel => {
  const companyId = useAccountCompanyId();

  const { data } = useQuery<AuthCurrentUserQuery>(AuthCurrentUserDocument, {
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  const currentCompany = data?.currentUserPureQuery?.mainCompany;

  const { request: companyCreateAmoTaskToBill, loading } = useCompanyCreateAmoTaskToBill();

  const paymentByInvoiceRequest = async () => {
    const isOk = await companyCreateAmoTaskToBill(companyId);

    return isOk;
  };

  return {
    isPaymentByInvoiceRequested: Boolean(currentCompany?.isPaymentByInvoiceRequested),
    isPaymentRequestLoading: loading,
    paymentByInvoiceRequest,
  };
};

export default useInvoiceRequestPresenter;
